import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import ICalculatorComponent, { Result } from '@components/FormFlow/Interfaces/FormflowComponents/ICalculatorComponent';
import ISection from '@components/FormFlow/Interfaces/ISection';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import QuillHtmlComponent from '@components/QuillHtmlEditorComponent';
import { faDivide, faMinus, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Checkbox, InputNumber, Radio, Row, Select, Tag } from 'antd';
import { TweenOneGroup } from 'rc-tween-one';
import React from 'react';


const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const Option = Select.Option;

interface ICalculatorTaskComponentStateType {
  result: Result[];
  defaultResult: string;
  defaultCheckedResult: boolean;
  decimalPlace: number;
  step: number;
  tags: string[];
  inputValue: string;
  formula: string;
  currentSection: any;
};

export class CalculatorComponent implements ICalculatorComponent {
  id: string;
  formula: string; // ({{a}}-{{b}})+50
  title: string;
  type: ComponentType;
  results?: Result[];
  keys?: string[];
  decimalPlaces: number;
  defaultResult: string;
  constructor() {
    this.id = '';
    this.title = ''
    this.formula = '';
    this.type = ComponentType.CALCULATOR;
    this.results = [{
      label: '',
      min: 0,
      max: 0
    }];
    this.decimalPlaces = 0;
    this.defaultResult = '';
    return this;
  }
}

export default class CalculatorTaskComponent extends React.Component<ICalculatorComponent, ICalculatorTaskComponentStateType> {

  constructor(props: ICalculatorComponent) {
    super(props);

    this.state = {
      result: this.props.results || [],
      defaultResult: this.props.defaultResult,
      defaultCheckedResult: this.props.defaultResult !== '' ? true : false,
      decimalPlace: this.props.decimalPlaces || 0,
      step: this.props.decimalPlaces || 0,
      tags: [],
      inputValue: "",
      formula: '',
      currentSection: ''
    };
  }
  componentDidMount() {
    this.rebuildFormula()
  }

  rebuildFormula = async () => {
    const { formula } = this.props
    if (this.props.formula !== '') {
      const plus = ',' + formula.slice(formula.indexOf('+'), formula.indexOf('+') + 1) + ','
      const minus = ',' + formula.slice(formula.indexOf('-'), formula.indexOf('-') + 1) + ','
      const times = ',' + formula.slice(formula.indexOf('*'), formula.indexOf('*') + 1) + ','
      const divide = ',' + formula.slice(formula.indexOf('/'), formula.indexOf('/') + 1) + ','
      const first = ',' + formula.slice(formula.indexOf('('), formula.indexOf('(') + 1) + ','
      const last = ',' + formula.slice(formula.indexOf(')'), formula.indexOf(')') + 1) + ','
      const result = formula.replace(/[+\s\$]/g, plus).replace(/[-\s\$]/g, minus).replace(/[*\s\$]/g, times).replace(/[/\s\$]/g, divide).replace(/[(\s\$]/g, first).replace(/[)\s\$]/g, last)

      let newFormula = result.split(',')

      this.setState({ tags: newFormula })
    }

  }

  //#region HANDLERS
  handleAddNewResult = async () => {
    this.setState({
      result: this.state.result.concat(
        [{ label: '', min: 0, max: 0 }])
    });
  }

  handleRemoveResult = (index: number) => async () => {
    this.setState({
      result: this.state.result.filter((section: any, sindex: number) => index !== sindex),
    });
  }

  handleDefaultLabelChange = async (evt: any) => {
    this.setState({ defaultResult: evt });
  }

  handleInputLabelChange = (idx: any) => (evt: any) => {
    const newResult = this.state.result.map((resultItems, sidx) => {
      if (idx !== sidx) return resultItems;
      return { ...resultItems, label: evt };
    });
    this.setState({ result: newResult });
  }

  handleMinChange = (idx: any) => (evt: any) => {
    const newResult = this.state.result.map((resultItems, sidx) => {
      if (idx !== sidx) return resultItems;
      return { ...resultItems, min: evt };
    });
    this.setState({ result: newResult });
  }

  handleMaxChange = (idx: any) => (evt: any) => {
    const newResult = this.state.result.map((resultItems, sidx) => {
      if (idx !== sidx) return resultItems;
      return { ...resultItems, max: evt };
    });
    this.setState({ result: newResult });
  }



  handleDefaultCheckedChange = async (evt: any) => {
    this.setState({ defaultCheckedResult: evt.target.checked });
  }

  handleDecimalPlaceChange = async (evt: any) => {
    this.setState({ decimalPlace: evt.target.value });
    switch (this.state.decimalPlace) {
      case 0: {
        this.setState({ step: 0 });
        return;
      }
      case 1: {
        this.setState({ step: 0.1 });
        return;
      }
      case 2: {
        this.setState({ step: 0.01 });
        return;
      }
      case 3: {
        this.setState({ step: 0.001 });
        return;
      }
      case 4: {
        this.setState({ step: 0.0001 });
        return;
      }

      default:
        return;
    }
  }

  handleComponentToFormula = async (e: any) => {
    this.setState({ inputValue: e })
    const { inputValue } = this.state;
    let { tags } = this.state;
    tags = [...tags, inputValue];

    console.log(tags);
    this.setState({
      tags,
    });
    console.log('newtags', this.state.tags);
  };

  handleOperator = async (e: any) => {
    this.setState({ inputValue: e.target.value })
    const { inputValue } = this.state;
    let { tags } = this.state;
    tags = [...tags, inputValue];

    console.log(tags);
    this.setState({
      tags,
    });
  };


  handleClose = async (removedTag: any) => {
    console.log('index', removedTag);
    this.state.tags.splice(removedTag - 1, 2)
    await this.forceUpdate();
    console.log('newtags', this.state.tags);
  };


  //#endregion

  getComponents(currentSection: ISection | null) {
    let options: JSX.Element[] = []
    if (currentSection) {
      const componentsNumber = currentSection.components.filter((e: any) => e.type === ComponentType.NUMBER)
      for (let items of componentsNumber) {
        options.push(
          <Option key={items.id} value={'{{' + currentSection.id + '.' + items.id + '}}'}>
            {items.title}
          </Option>
        )
      }
    }
    return options;

  }

  onSubmitCalculatorComponent = async (updateFormflowWithComponent: (component: IBaseComponent) => void) => {
    this.setState({ formula: this.state.tags.toString().replace(/[,\s\$]/g, '') })

    const newCalculatorDataComponent: ICalculatorComponent = {
      id: this.props.id,
      type: ComponentType.CALCULATOR,
      title: I18n.l("formflow.components.calculatorComponent.title"),
      description: undefined,
      required: false,
      formula: this.state.formula,
      decimalPlaces: this.state.decimalPlace,
      results: this.state.result ? this.state.result : undefined,
      defaultResult: this.state.defaultResult
    }
    updateFormflowWithComponent(newCalculatorDataComponent);
    console.log('Calculator', newCalculatorDataComponent)
  }

  getTags = (currentSection: any) => {
    const tagElem: JSX.Element[] = [];
    if (this.state.tags.length > 0) {
      for (let [idx, tags] of this.state.tags.entries()) {

        switch (tags) {
          case '+': {
            tagElem.push(
              <Icon style={{ fontSize: '20px', marginRight: '10px' }} icon={faPlus} />
            )
          } break;
          case '-': {
            tagElem.push(
              <Icon style={{ fontSize: '20px', marginRight: '10px' }} icon={faMinus} />
            )
          } break;
          case '*': {
            tagElem.push(
              <Icon style={{ fontSize: '20px', marginRight: '10px' }} icon={faTimes} />
            )
          } break;
          case '/': {
            tagElem.push(
              <Icon style={{ fontSize: '20px', marginRight: '10px' }} icon={faDivide} />
            )
          } break;
          case '(': {
            tagElem.push(
              <span style={{ fontWeight: 900, fontSize: '20px', marginRight: '10px' }} >(</span>
            )
          } break;
          case ')': {
            tagElem.push(
              <span style={{ fontWeight: 900, fontSize: '20px', marginRight: '10px' }} >)</span>
            )
          } break;
          default: {
            if (tags !== '') {
              const label = currentSection.components.find((e: any) => ('{{' + currentSection.id + '.' + e.id + '}}') === tags)
              tagElem.push(
                <span style={{ display: "inline-block" }}>
                  <Tag
                    // key={Date.now()}
                    className='tag-style'
                    closable
                    onClose={(e: any) => {
                      e.preventDefault();
                      this.handleClose(idx);
                    }}
                  >
                    {label.title}
                  </Tag>
                </span>
              )
            }
          } break;
        }
      }
    }
    return tagElem;
  };

  render() {
    const {
      tags
    } = this.state

    return (
      <div>
        <Wrapper>
          <h3>{I18n.l("formflow.components.calculatorComponent.title")}</h3>
          <p style={{ width: '50%' }} > {I18n.l("formflow.components.calculatorComponent.description")} </p>
          <div
            style={{ marginTop: '2rem', marginBottom: '0.5rem', paddingRight: '50px' }}
          >
            <div className='card-box'>

              <FormflowContext.Consumer>
                {({ currentSection }) => (
                  <>
                    <div >
                      <TweenOneGroup>
                        {this.getTags(currentSection)}
                      </TweenOneGroup>
                    </div>
                    <Select
                      className='select-style'
                      placeholder={I18n.l("formflow.labels.selectComponentConditionPlaceholder")}
                      onChange={this.handleComponentToFormula}
                    >
                      {this.getComponents(currentSection)}
                    </Select>
                    <RadioGroup className='operator-style' onChange={this.handleOperator}>
                      <RadioButton value={'+'}><Icon icon={faPlus} /> </RadioButton>
                      <RadioButton value={'-'}><Icon icon={faMinus} /> </RadioButton>
                      <RadioButton value={'*'}><Icon icon={faTimes} /> </RadioButton>
                      <RadioButton value={'/'}><Icon icon={faDivide} /> </RadioButton>
                      <RadioButton style={{ fontWeight: 900 }} value={'('}>(</RadioButton>
                      <RadioButton style={{ fontWeight: 900 }} value={')'}>)</RadioButton>
                    </RadioGroup>
                  </>
                )}
              </FormflowContext.Consumer>
            </div>

            <DividerBorder />

            <span className='span-style' >{I18n.l("formflow.components.calculatorComponent.resultOptional")}</span>
            <div style={{ marginTop: '2rem' }} >
              <span style={{ marginRight: '10px' }}>{I18n.l("formflow.components.calculatorComponent.decimalPlace")}</span>
              <RadioGroup defaultValue={this.state.decimalPlace} onChange={this.handleDecimalPlaceChange}>
                <RadioButton value={0}>0</RadioButton>
                <RadioButton value={1}>0,0</RadioButton>
                <RadioButton value={2}>0,00</RadioButton>
                <RadioButton value={3}>0,000</RadioButton>
                <RadioButton value={4}>0,0000</RadioButton>
              </RadioGroup>
            </div>
            {this.state.result.map((items, idx) => (
              <div key={idx}>
                <div style={{ marginTop: '3rem', marginBottom: '3rem' }} >
                  <span>{I18n.l("formflow.components.calculatorComponent.optionalResult")}</span>
                  <InputNumber
                    step={this.state.step}
                    value={items.min}
                    style={{ marginLeft: '10px', marginRight: '10px' }}
                    onChange={this.handleMinChange(idx)}
                  />
                  {I18n.l("form.taskflowschedule.labels.and")}
                  <InputNumber
                    step={this.state.step}
                    value={items.max}
                    style={{ marginLeft: '10px', marginRight: '10px' }}
                    onChange={this.handleMaxChange(idx)}
                  />
                  {I18n.l("formflow.components.calculatorComponent.showMessage")}
                </div>
                <QuillHtmlComponent
                  defaultValue={items.label}
                  placeholder={I18n.l("form.placeholders.textComponentMulti")}
                  onTextChange={this.handleInputLabelChange(idx)}
                />
                <Button
                  style={{ border: '0px', float: 'right' }}
                  type="danger"
                  ghost onClick={this.handleRemoveResult(idx)}
                >
                  {I18n.l("formflow.components.calculatorComponent.deleteMessage")}
                </Button>
              </div>

            ))}
            <DividerBorder />
            < Button
              style={{ marginLeft: '-15px', fontWeight: 'bold', marginBottom: '16px' }}
              onClick={this.handleAddNewResult}
              className="goepik-btn-border-main-withoutbold"
            >
              <Icon icon={faPlus} /> {I18n.l("formflow.components.calculatorComponent.newMessage")}
            </Button>

            <div style={{ marginBottom: '2rem' }} >
              <Checkbox
                defaultChecked={this.state.defaultCheckedResult}
                onChange={this.handleDefaultCheckedChange}
              >
                {I18n.l("formflow.components.calculatorComponent.defaultResultChecked")}
              </Checkbox>
            </div>

            <QuillHtmlComponent
              defaultValue={this.props.defaultResult}
              placeholder={I18n.l("form.placeholders.textComponentMulti")}
              onTextChange={this.handleDefaultLabelChange}
            />
          </div>
        </Wrapper>
        <FormflowContext.Consumer>
          {({ destroyComponentModalWindow, updateFormflowWithComponent }) => (
            <div>
              <ButtonStyle>
                <Row type="flex" justify="end">
                  <Button className="button-cancel" type="primary" onClick={destroyComponentModalWindow} ghost>{I18n.l('common.cancel')}</Button>
                  <Button
                    className="button-save"
                    type="primary"
                    disabled={tags.length > 0 ? false : true}
                    onClick={() => { this.onSubmitCalculatorComponent(updateFormflowWithComponent) }} >
                    {I18n.l('common.save')}
                  </Button>
                </Row>
              </ButtonStyle>
            </div>
          )}
        </FormflowContext.Consumer>
      </div>
    );
  }
}

//#region CSS
const Wrapper = styled.div`
  margin-top: 3rem;    
  margin-left: 3rem;
  .span-style{
    font-size: 16px;
    font-weight: bold;
    color:  ${Theme.secondary.midGrey};
  }
  .card-box{
    position: relative;
    width: 60%;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    background: ${Theme.secondary.lightGrey};
    border-radius: 5px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    min-height: 150px;
    .select-style {
      width: 40%;
      position: absolute;
      bottom: 10px;
    }
    .operator-style {
      width: 50%;
      position:absolute;
      bottom: 10px;
      right: 10px;
    }
    .tag-style {
      margin-right: 10px;
      padding: 3px;
      border-radius: 5px;
      background: ${Theme.secondary.darkWhite};
      border: 1px solid ${Theme.secondary.midGrey};
    }
  }
`;
const DividerBorder = styled.div`
    margin-top: 3rem;    
    margin-bottom: 2rem;
    border-bottom: 1px solid ${Theme.secondary.midGrey};
`


const ButtonStyle = styled.div`
    float:right;
    margin-top: 15vh;
    margin-right: 50px;
    
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`;
//#endregion
